import type { GlobalHeaderDOMProps } from '../GlobalSearch';
import type { HeaderPortalDOMProps } from './Header.types';

import CartSummaryAccessibilityLogger from '../../../cart/components/atoms/CartSummaryAccessibilityLogger';
import ComponentPortals from '../../../common/components/molecules/ComponentPortals';
import { useIsB2BRoute } from '../../../common/utils/b2bUtils';
import EcommerceSearch from '../../../ecommerce/components/EcommerceLayout/EcommerceSearch';
import GlobalSearch from '../GlobalSearch';
import HeaderFluidBanner from './HeaderFluidBanner';
import HeaderStickyBanner from './HeaderStickyBanner';

const GlobalHeader = (props: {
    stayAfterLoginLogoutRedirect?: boolean;
    performFullSearch?: (query: string, originalQuery?: string) => void;
    hideB2BSwitch: boolean;
}) => {
    const isB2B = useIsB2BRoute();

    return (
        <>
            <CartSummaryAccessibilityLogger />
            <ComponentPortals
                cmpName="HeaderFluidBanner"
                render={(domProps: HeaderPortalDOMProps) => (
                    <HeaderFluidBanner
                        featuredNavigation={{
                            items: domProps.featuredNavigation?.items,
                        }}
                        headerTheme={domProps.headerTheme}
                        hideB2BSwitch={props.hideB2BSwitch}
                        stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect || false}
                    />
                )}
            />
            <ComponentPortals
                cmpName="HeaderStickyBanner"
                render={(domProps: GlobalHeaderDOMProps) => (
                    <HeaderStickyBanner
                        featuredNavigation={{
                            items: domProps.featuredNavigation?.items,
                        }}
                        headerTheme={domProps.headerTheme}
                        stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect || false}
                        searchSlot={
                            // b2b customers should always see EcommerceSearch on all pages
                            isB2B ? (
                                <EcommerceSearch />
                            ) : (
                                <GlobalSearch
                                    currentPage={domProps.currentPage}
                                    searchDisabled={domProps.searchDisabled}
                                    query={domProps.query}
                                    headerTheme={domProps.headerTheme}
                                    performFullSearch={props.performFullSearch}
                                />
                            )
                        }
                    />
                )}
            />
        </>
    );
};

export default GlobalHeader;
